/* Report download form */
(function () {
    const form = document.querySelector("[data-download-form]");

    if (!form) {
        return;
    }

    const status = form.querySelector("[data-download-status]");
    const submitButton = form.querySelector('button[type="submit"]');
    const emailInput = form.querySelector('input[name="email"]');
    const interestAreaSelect = form.querySelector('select[name="interest_area"]');
    const processingConsentInput = form.querySelector('input[name="processing_consent"]');
    const promotionalConsentInput = form.querySelector('input[name="promotional_consent"]');
    const processingConsentLabel = form.querySelector("[data-processing-consent-copy]");
    const promotionalConsentLabel = form.querySelector("[data-promotional-consent-copy]");
    const honeypotInput = form.querySelector("[data-honeypot]");
    const submitEndpoint = form.dataset.submitEndpoint || "";
    const documentId = form.dataset.documentId || "";
    const actionType = form.dataset.actionType || "report_download";
    const consentVersion = form.dataset.consentVersion || "";
    const privacyPolicyVersion = form.dataset.privacyPolicyVersion || "";
    const requiredTextFields = [
        "first_name",
        "last_name",
        "company",
        "country",
        "job_title"
    ].map(function (fieldName) {
        return form.querySelector('input[name="' + fieldName + '"]');
    }).filter(Boolean);
    const cooldownSeconds = Number.parseInt(form.dataset.rateLimitSeconds || "60", 10);
    const cooldownMs = Math.max(cooldownSeconds, 1) * 1000;
    const downloadUrl = form.dataset.downloadUrl;
    const downloadName = form.dataset.downloadName || "";
    const rateLimitKey = "wb-report-download-last-at";
    const sessionStorageKey = "wb-report-download-session-id";
    let cooldownTimer = null;
    let isSubmitting = false;

    const messages = {
        first_name: "Enter your first name.",
        last_name: "Enter your last name.",
        email_required: "Enter your work email address.",
        email_invalid: "Enter a valid work email address.",
        company: "Enter your company name.",
        country: "Enter your country.",
        job_title: "Enter your job title or role.",
        form_invalid: "Please complete all required fields and confirm the required consent checkbox before downloading the report.",
        processing_consent: "Please consent to the processing of your personal data before submitting."
    };

    function setStatus(message, state) {
        if (!status) {
            return;
        }

        status.textContent = message;
        status.classList.remove("is-error", "is-success");

        if (state) {
            status.classList.add(state);
        }
    }

    function getLastDownloadAt() {
        const lastDownloadAt = Number.parseInt(window.localStorage.getItem(rateLimitKey) || "0", 10);

        if (Number.isNaN(lastDownloadAt)) {
            return 0;
        }

        return lastDownloadAt;
    }

    function getRemainingCooldown() {
        const elapsed = Date.now() - getLastDownloadAt();

        return Math.max(cooldownMs - elapsed, 0);
    }

    function updateCooldownUi() {
        if (!submitButton) {
            return;
        }

        const remainingMs = getRemainingCooldown();

        if (remainingMs > 0) {
            const remainingSeconds = Math.ceil(remainingMs / 1000);

            submitButton.disabled = true;
            setStatus("Please wait " + remainingSeconds + " seconds before downloading again.", "is-error");

            return;
        }

        submitButton.disabled = isSubmitting;

        if (status && status.classList.contains("is-error") && status.textContent.indexOf("Please wait") === 0) {
            setStatus("");
        }
    }

    function startCooldownTimer() {
        if (cooldownTimer) {
            window.clearInterval(cooldownTimer);
        }

        updateCooldownUi();
        cooldownTimer = window.setInterval(function () {
            updateCooldownUi();

            if (getRemainingCooldown() <= 0 && cooldownTimer) {
                window.clearInterval(cooldownTimer);
                cooldownTimer = null;
            }
        }, 1000);
    }

    function normalizeText(value) {
        return value.trim().replace(/\s+/g, " ");
    }

    function createRandomId() {
        if (window.crypto && typeof window.crypto.randomUUID === "function") {
            return window.crypto.randomUUID();
        }

        return "wb-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    }

    function getSessionId() {
        try {
            const existingId = window.sessionStorage.getItem(sessionStorageKey);

            if (existingId) {
                return existingId;
            }

            const nextId = createRandomId();
            window.sessionStorage.setItem(sessionStorageKey, nextId);
            return nextId;
        } catch (error) {
            return "";
        }
    }

    function extractConsentCopy(label) {
        if (!label) {
            return "";
        }

        const copyNode = label.querySelector("span");

        if (!copyNode) {
            return "";
        }

        return normalizeText(copyNode.textContent || "");
    }

    function validateTextInputs() {
        let isValid = true;

        requiredTextFields.forEach(function (input) {
            const value = normalizeText(input.value);
            const message = messages[input.name] || "Please fill out this field.";

            input.setCustomValidity("");
            input.value = value;

            if (!value) {
                input.setCustomValidity(message);
                isValid = false;
            }
        });

        return isValid;
    }

    function validateEmail() {
        if (!emailInput) {
            return true;
        }

        const value = normalizeText(emailInput.value).toLowerCase();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        emailInput.setCustomValidity("");
        emailInput.value = value;

        if (!value) {
            emailInput.setCustomValidity(messages.email_required);
            return false;
        }

        if (!emailPattern.test(value)) {
            emailInput.setCustomValidity(messages.email_invalid);
            return false;
        }

        return true;
    }

    function validateConsent() {
        if (!processingConsentInput) {
            return true;
        }

        processingConsentInput.setCustomValidity("");

        if (!processingConsentInput.checked) {
            processingConsentInput.setCustomValidity(messages.processing_consent);
            return false;
        }

        return true;
    }

    function revealFirstValidationError() {
        const invalidField = form.querySelector(":invalid");

        if (!invalidField) {
            return;
        }

        const message = invalidField.validationMessage || messages.form_invalid;

        setStatus(message, "is-error");

        if (typeof invalidField.reportValidity === "function") {
            invalidField.reportValidity();
        }

        if (typeof invalidField.focus === "function") {
            invalidField.focus();
        }
    }

    function serializeForm() {
        const formData = new window.FormData(form);

        return {
            first_name: normalizeText(formData.get("first_name") || ""),
            last_name: normalizeText(formData.get("last_name") || ""),
            email: normalizeText(formData.get("email") || "").toLowerCase(),
            company: normalizeText(formData.get("company") || ""),
            country: normalizeText(formData.get("country") || ""),
            job_title: normalizeText(formData.get("job_title") || ""),
            interest_area: normalizeText(formData.get("interest_area") || ""),
            promotional_consent: Boolean(formData.get("promotional_consent")),
            processing_consent: Boolean(formData.get("processing_consent")),
            website: normalizeText(formData.get("website") || ""),
            page_source: window.location.href,
            document_id: documentId,
            action_type: actionType,
            consent_version: consentVersion,
            privacy_policy_version: privacyPolicyVersion,
            consent_text: extractConsentCopy(processingConsentLabel),
            promotional_consent_text: promotionalConsentInput && promotionalConsentInput.checked ? extractConsentCopy(promotionalConsentLabel) : "",
            session_id: getSessionId()
        };
    }

    function setSubmittingState(nextState) {
        isSubmitting = nextState;

        if (submitButton) {
            submitButton.disabled = nextState || getRemainingCooldown() > 0;
        }

        form.classList.toggle("is-submitting", nextState);
    }

    function getSubmitEndpoint() {
        if (!submitEndpoint) {
            return "";
        }

        if (/^https?:\/\//i.test(submitEndpoint)) {
            return submitEndpoint;
        }

        if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
            return "http://127.0.0.1:8787" + submitEndpoint;
        }

        return submitEndpoint;
    }

    async function submitLead(payload, requestId) {
        const endpoint = getSubmitEndpoint();

        if (!endpoint) {
            throw new Error("The report form endpoint is not configured.");
        }

        const response = await window.fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Request-ID": requestId
            },
            body: JSON.stringify(payload)
        });
        const data = await response.json().catch(function () {
            return {};
        });

        if (!response.ok || !data.ok) {
            throw new Error(data.message || "We couldn't save your request right now. Please try again in a moment.");
        }
    }

    async function triggerDownload() {
        const response = await window.fetch(downloadUrl, {
            credentials: "same-origin"
        });

        if (!response.ok) {
            throw new Error("We saved your request, but the PDF could not be downloaded right now.");
        }

        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = objectUrl;
        link.download = downloadName || "western-balkans-nearshoring.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
        }, 1000);
    }

    requiredTextFields.forEach(function (input) {
        input.addEventListener("input", function () {
            input.setCustomValidity("");
            if (status && status.classList.contains("is-error")) {
                setStatus("");
            }
        });

        input.addEventListener("blur", function () {
            input.value = normalizeText(input.value);
        });
    });

    if (emailInput) {
        emailInput.addEventListener("input", function () {
            emailInput.setCustomValidity("");
            if (status && status.classList.contains("is-error")) {
                setStatus("");
            }
        });

        emailInput.addEventListener("blur", function () {
            emailInput.value = normalizeText(emailInput.value).toLowerCase();
        });
    }

    if (processingConsentInput) {
        processingConsentInput.addEventListener("change", function () {
            processingConsentInput.setCustomValidity("");
            if (status && status.classList.contains("is-error")) {
                setStatus("");
            }
        });
    }

    if (interestAreaSelect) {
        interestAreaSelect.required = false;

        interestAreaSelect.addEventListener("change", function () {
            interestAreaSelect.setCustomValidity("");
            if (status && status.classList.contains("is-error")) {
                setStatus("");
            }
        });
    }

    updateCooldownUi();

    form.addEventListener("submit", async function (event) {
        event.preventDefault();

        if (!downloadUrl) {
            setStatus("Add your PDF to assets/downloads/western-balkans-nearshoring.pdf.", "is-error");
            return;
        }

        if (!validateTextInputs() || !validateEmail() || !validateConsent() || !form.checkValidity()) {
            revealFirstValidationError();
            return;
        }

        if (getRemainingCooldown() > 0) {
            startCooldownTimer();
            return;
        }

        const payload = serializeForm();
        const requestId = createRandomId();

        if (honeypotInput && payload.website) {
            setStatus("Thanks. Your request is being reviewed.", "is-success");
            return;
        }

        try {
            setSubmittingState(true);
            setStatus("Submitting your request…");
            await submitLead(payload, requestId);
            window.localStorage.setItem(rateLimitKey, String(Date.now()));
            await triggerDownload();
            setStatus("Download started. If nothing happens, please check your browser download settings.", "is-success");
            startCooldownTimer();
        } catch (error) {
            setStatus(error.message || "We couldn't save your request right now. Please try again in a moment.", "is-error");
        } finally {
            setSubmittingState(false);
        }
    });
})();
